import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySinkAdapter } from './copysink.adapter';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { EventStreamCopySink } from 'app/model/pipeline/copysink/event-stream.copysink';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import type { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EventStreamCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        maxConcurrentConnections: '*',
        writeBehavior: '*'
    }
})
export class EventStreamCopySinkAdapter extends CopySinkAdapter<EventStreamCopySink, Model.EventStreamSink> {
    protected model(): IModel {
        return EventStreamCopySink.MODEL;
    }

    protected override async _toResource(model: EventStreamCopySink): Promise<Model.EventStreamSink> {
        const result: Model.EventStreamSink = {
            type: this.model().name
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.writeBehavior = ValueAdapter.toResource(model, EventStreamCopySink.WRITE_BEHAVIOR);
        return result;
    }

    protected override async _toModel(resource: Model.EventStreamSink, owner: Activity): Promise<EventStreamCopySink> {
        const result = Owned.create<EventStreamCopySink>(Metamodel.modelFor(EventStreamCopySink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, EventStreamCopySink.WRITE_BEHAVIOR, resource.writeBehavior);
        return result;
    }
}
